module.exports = __webpack_public_path__ + "media/newstyle/images/stars_2-red-5497a0b67fda5463813ca1b52ea5fdcb.svg";